import React from 'react';

const ModuleItemActivator = (props) => {

    const handleActivation = () => {
        props.activateModuleItem(props.moduleName, props.gtin);
    };

    return (
        <div>
            <label className="switch switch-text switch-success form-control-label">
                <input onClick={handleActivation} type="checkbox" className="switch-input form-check-input" value="on"
                       defaultChecked={false}/>
                <span className="switch-label" data-on="On" data-off="Off"/>
                <span className="switch-handle"/>
            </label>
            <span>&nbsp;Grund: {props.deactivationReason}</span>
        </div>
    );
};

export default ModuleItemActivator;



// WEBPACK FOOTER //
// ./src/admin/module/overview/ModuleItemActivator.js